angular.module('BGEHeroes.controllers.Lepes3', [ ])

.controller('lepes3Ctrl', ['$scope', '$log', '$location', 'Gateway', '$rootScope', '$window',
	function($scope, $log, $location, Gateway, $rootScope, $window){
	
		$rootScope.loading = true;
		
		$scope.messageCall = function ( command, param ) {
			
			if (command == 'goto'){
				$rootScope.loading = true;		
				$location.url(param);
				$location.replace();
				if (!$rootScope.$$phase) $rootScope.$apply();
			}
			
			if (command == 'ready'){
				$rootScope.loading = false;
				if (!$rootScope.$$phase) $rootScope.$apply();
			}
			
			console.log('Command: ' + command + ' Message: ' + param );
			
		}
		
		$log.log ("Lepes3");
		//$rootScope.loading = false;
		
	}
]);